"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseLogger_1 = require("./BaseLogger");
var SQlLogger = (function (_super) {
    __extends(SQlLogger, _super);
    function SQlLogger(name, url, interval, onLogs, perLength) {
        return _super.call(this, name, url, interval, onLogs, perLength) || this;
    }
    Object.defineProperty(SQlLogger, "isSupport", {
        get: function () {
            return 'localStorage' in window;
        },
        enumerable: true,
        configurable: true
    });
    return SQlLogger;
}(BaseLogger_1.BaseLogger));
exports.SQlLogger = SQlLogger;
//# sourceMappingURL=SQlLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/log/SQlLogger.js
// module id = vn7O
// module chunks = 0